export default __webpack_public_path__ + "static/404-Error-Page-MB-pup_03-328fe6ae4a40eaafaf0081e923247335.png";